import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../state/store";

export const noneEntry: object = {
    id: 0,
    name: "none",
    price: "0.00",
    imageRef: "none.png",
    urlExtension: "",
    SupplierId: 5,
    Supplier: {
        id: 5,
        supplierName: "SolomonMods",
        website: "solomonmods-gameboy-configurator.onrender.com/",
    },
};

export interface ModsState {
    dataArray: Array<object>;
    title: string;
}

export const modsSlice = createSlice({
    name: "mods",
    initialState: {
        dataArray: [noneEntry],
        title: "",
    },
    reducers: {
        updateDataArray: (state, action: PayloadAction<Array<object>>) => {
            state.dataArray = action.payload;
        },
        updateTitle: (state, action: PayloadAction<string>) => {
            state.title = action.payload;
        },
    },
});

export const { updateDataArray, updateTitle } = modsSlice.actions;

export const selectDataArray = (state: RootState) => state.mods.dataArray;
export const selectTitle = (state: RootState) => state.mods.title;

export default modsSlice.reducer;
